'use client';

import Link from 'next/link';
import { Button } from '@/components/ui/Button';
import Image from 'next/image';
import { ArrowRight } from 'lucide-react';
import HowItWorks from './HowItWorks';
import { usePageView } from '@/lib/hooks/usePageView';

const HeroScreenshot = () => {
  return (

    <div className="mt-16 mx-8">
      <Image
        src="/static/images/marketing/scenario_top_left.PNG"
        alt="App screenshot"
        className="m-auto h-[95%] lg:max-lg:w-[95%] 2xl:max-w-[72rem] p-2 border-2 border-gray-300 rounded-lg"
        width={3840}
        height={100}
      />
    </div>
  );
};

export default function Hero() {
  usePageView();
  return (
    <div>
      {/* Hero Section with simpler layout */}
      <section className="bg-white py-16 md:py-24 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Column - Content */}
            <div className="space-y-8">
              <div className="space-y-6">
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-black leading-relaxed">
                  Track Every Shipment. <br/>
                  Predict Every Delay.  <br/>
                  Optimize Every Cost.
                </h1>
                
                <div className="space-y-6">
                  <p className="text-lg md:text-xl text-black leading-relaxed">
                    Supply chain visibility for shippers, brokers, forwarders, and 3PLs. Real-time tracking, cost predictions, and compliance tools for your operations or client services.
                  </p>
                  <p className="text-lg md:text-xl text-black-700 leading-relaxed">
                    Stop losing money to unexpected delays and hidden costs. Get complete visibility from origin to destination.
                  </p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                <Link href={`/dashboard/${process.env.NEXT_PUBLIC_DEMO_VULCAN_ID}`}>
                  <Button 
                    className="bg-blue-900 hover:bg-blue-800 text-white text-xl px-10 py-4 font-semibold transition-colors h-16 shadow-lg rounded-lg">
                    See It In Action
                    <ArrowRight className="ml-3 h-6 w-6" />
                  </Button>
                </Link>
              </div>
            </div>

            {/* Right Column - Visual/Image */}
            <div className="relative">
              <div className="relative bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6 shadow-xl">
                <Image
                  src="/static/images/marketing/main_hero.jpeg"
                  alt="SupplySense360 Capabilities"
                  className="rounded-xl shadow-lg border border-gray-200"
                  width={700}
                  height={500}
                  priority
                />
                
                {/* Floating elements for visual interest */}
                <div className="absolute -top-4 -right-4 bg-white rounded-full p-4 shadow-lg border">
                  <div className="w-6 h-6 bg-green-500 rounded-full animate-pulse"></div>
                </div>
                
                <div className="absolute -bottom-4 -left-4 bg-white rounded-lg p-3 shadow-lg border">
                  <div className="text-sm font-semibold text-gray-800">Real-time tracking</div>
                  <div className="text-xs text-gray-500">99.9% accuracy</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Keep your existing components */}
      <HowItWorks />
      <HeroScreenshot />
    </div>
  );
}